import currency from "currency.js";
import { Form, Table } from "react-bootstrap";
import { FilesAttachments } from "../../utils/Attachments";
import { useMemo } from "react";

// Extracted ItemTable component
export function ItemTable({
  tableData,
  selectedData,
  onSelected,
  selectAll,
  updateTableItem,
  disableInput,
  vendorAttachments,
  backendUrl,
  isSelected,
}) {
  const allSelected = useMemo(() => {
    const vendorRFQItemIds = tableData?.map((item) => item.id);
    const selectedItemIds = selectedData?.map((item) => item.id);
    const allSelected = vendorRFQItemIds?.every((id) =>
      selectedItemIds.includes(id),
    );

    return allSelected;
  }, [tableData, selectedData]);

  return (
    <div className="mx-3">
      <div className="table-responsive shadow-sm rounded border">
        <Table hover className="align-middle mb-0 procurement-table">
          <thead>
            <tr>
              <th className="selection-col">
                <input
                  type="checkbox"
                  onChange={selectAll}
                  checked={allSelected}
                  disabled={isSelected}
                />
              </th>

              <th>Code</th>
              <th>Item</th>
              <th className="text-left">Unit Cost</th>
              <th className="text-center">Qty</th>
              <th className="text-left">Subtotal</th>
              <th>Vendor Remark</th>
              <th>Internal Comments</th>
            </tr>
          </thead>

          <tbody>
            {tableData.map((row, index) => {
              const selected = selectedData.some((item) => item.id === row.id);

              return (
                <tr key={row.id}>
                  <td>
                    <input
                      type="checkbox"
                      onChange={() => onSelected(row)}
                      checked={selected}
                      disabled={isSelected}
                    />
                  </td>

                  <td className="fw-medium text-muted">{row.barcode}</td>

                  <td className="item-name">{row.itemName}</td>

                  <td className="subtotal-cell">
                    {!isNaN(row.amount)
                      ? currency(row.amount, {
                          precision: 2,
                          symbol: "",
                        }).format()
                      : 0}
                  </td>

                  <td className="text-center fw-semibold">{row.quantity}</td>

                  <td className="subtotal-cell">
                    {!isNaN(row.amount * row.quantity)
                      ? currency(row.amount, {
                          precision: 2,
                          symbol: "",
                        })
                          .multiply(row.quantity)
                          .format()
                      : 0}
                  </td>

                  <td className="remark-cell">{row?.remark || "-"}</td>

                  <td className="remark-cell">
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={row?.comments || ""}
                      name="comments"
                      onChange={(e) =>
                        updateTableItem({
                          index,
                          name: "comments",
                          value: e.target.value,
                        })
                      }
                      disabled={!selected || isSelected}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      {vendorAttachments.length > 0 && (
        <div className="my-4 col-md-6">
          <p className="mb-2">Attachments:</p>
          <FilesAttachments
            files={vendorAttachments.map((attachment) =>
              !attachment?.fileId
                ? attachment
                : {
                    ...attachment,
                    systemFileName: `${attachment.systemFileName}/${
                      attachment.name
                    }`,
                  },
            )}
            colWidth="3"
            url={`${backendUrl}/api/vendors/files`}
            viewOnly
          />
        </div>
      )}

      {tableData.length > 0 && (
        <div className="d-flex justify-content-end my-3">
          <div className="gridChild gridChildBorderLeftBlue">
            <div className="gridChildLeft">
              <p className="gridChld1">
                {currency(
                  tableData.reduce(
                    (sum, item) => sum + item.amount * item.quantity,
                    0,
                  ),
                  { symbol: "" },
                ).format()}
              </p>
              <p className="gridChld2">Total</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
